import React, { useState } from "react";
import { Link } from "react-router-dom";

const ThinkChemistryWhy = () => {
  const [activeTab, setActiveTab] = useState("importance");

  const tabs = [
    { id: "importance", label: "🔬 Importance" },
    { id: "vision", label: "🌍 Vision & Mission" },
    { id: "values", label: "💎 Values" },
    { id: "engagement", label: "🎮 Engagement" },
    { id: "ptchampion", label: "🎮 PT Champion" },
    // { id: "earlyspark", label: "🎮 Early Spark" },        
    { id: "newchemsitry", label: "🎮 New Chemistry" },
    { id: "stakeholders", label: "👥 Stakeholders" },
    { id: "features", label: "⭐ Features" },
    { id: "audience", label: "📊 Audience" },
  ];

  const features = [
    { emoji: "📚", title: "Immersive Learning", desc: "Books, VisualBriefs, ChemTube & gamified content." },
    { emoji: "🧪", title: "Concept Clarity", desc: "Simplified, visual & application-based chemistry learning." },
    { emoji: "🤖", title: "AI Counselling", desc: "Career guidance powered by intelligent analytics." },
    { emoji: "🏆", title: "Certifications & Rankings", desc: "Skill validation & competitive benchmarking." },
    { emoji: "🎲", title: "Gamified Testing", desc: "Board games, quizzes & reaction simulations." },
    { emoji: "📈", title: "Career Alignment", desc: "Bridge between academics & industry pathways." },
  ];

  const stakeholders = [
    "🎓 School & Competitive Exam Students (6–12, NEET/JEE)",
    "👩‍🏫 Teachers & Educators",
    "🧪 Researchers & Scientists",
    "🏭 Pharma, Energy & Chemical Industries",
    "👨‍👩‍👧 Parents & Academic Institutions",
    "🌍 Global STEM Community",
  ];

  return (
    <div className="min-h-screen flex flex-col bg-black text-white [&_p]:text-white">
      <header className="border-b border-blue-400 px-4 py-3 bg-black sticky top-0 z-50">
        <h1 className="text-xl lg:text-2xl font-bold text-yellow-200 flex items-center gap-2">
          🔬 ThinkChemistry
        </h1>
        <p className="text-xs lg:text-sm text-gray-300">
          Chemistry is the science that connects.
        </p>
      </header>
      <nav className="bg-black border-b border-blue-400 p-2 sticky top-[70px] z-40">
        <div className="grid grid-cols-2 lg:grid-cols-7 gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`text-xs lg:text-sm font-semibold px-2 py-2 rounded-md transition
              ${
                activeTab === tab.id
                  ? "bg-blue-700 text-yellow-200"
                  : "bg-gray-900 hover:bg-blue-600"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </nav>
      <main className="flex-1 p-4 space-y-6">
        {activeTab === "importance" && (
          <section className="space-y-4">
            <h2 className="text-xl font-bold text-yellow-200 text-center">
              🔬 Why Chemistry Matters
            </h2>
            <p>
              Chemistry is the central science connecting physics, biology,
              medicine, energy, sustainability, materials and technology.
            </p>
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
              <div>💊 Medicines & Healthcare</div>
              <div>🔋 Clean Energy & Batteries</div>
              <div>🌱 Sustainable Agriculture</div>
              <div>🧬 Biotechnology</div>
              <div>🏭 Advanced Materials</div>
              <div>🤖 AI-driven Molecular Discovery</div>
            </div>
          </section>
        )}
        {activeTab === "vision" && (
          <section className="space-y-6">
            <div className="bg-gray-900 p-4 rounded-xl">
              <h3 className="text-lg font-semibold text-yellow-200">🌍 Vision</h3>
              <p>
                To become the world’s most immersive AI-powered chemistry
                learning and engagement ecosystem.
              </p>
            </div>

            <div className="bg-gray-900 p-4 rounded-xl">
              <h3 className="text-lg font-semibold text-yellow-200">🎯 Mission</h3>
              <ul className="list-disc list-inside space-y-2 text-sm [&_li]:text-gray-100">
                <li>Make chemistry simple, visual & practical.</li>
                <li>Bridge academia with real-world application.</li>
                <li>Promote green chemistry & sustainability.</li>
                <li>Enable career pathways in chemical sciences.</li>
              </ul>
            </div>
          </section>
        )}
        {activeTab === "values" && (
          <section className="grid grid-cols-1 lg:grid-cols-3 gap-4 text-sm">
            <div className="bg-gray-900 p-4 rounded-xl">🔬 Scientific Integrity</div>
            <div className="bg-gray-900 p-4 rounded-xl">🌱 Sustainability First</div>
            <div className="bg-gray-900 p-4 rounded-xl">🧠 Curiosity & Critical Thinking</div>
            <div className="bg-gray-900 p-4 rounded-xl">🤝 Collaboration</div>
            <div className="bg-gray-900 p-4 rounded-xl">🚀 Innovation</div>
            <div className="bg-gray-900 p-4 rounded-xl">🎓 Inclusive Learning</div>
          </section>
        )}
        {activeTab === "engagement" && (
          <section className="space-y-3 text-sm">
            <p>📚 Immersive Books & Digital Shelf</p>
            <p>🎥 ChemTube & Podcasts</p>
            <p>🎲 Chemistry Games & Simulations</p>
            <p>🏆 Rankings & Competitions</p>
            <p>🤖 AI Counselling & Smart Assessments</p>
            <p>💰 Reward-based Learning</p>
          </section>
        )}        
        {activeTab === "ptchampion" && (
          <section id="immersive-chemistry-kaizen" class="py-2 bg-black">
            <div class="max-w-6xl mx-auto px-6">

              <h2 class="text-3xl md:text-4xl font-bold text-yellow-200 mb-4">
                Immersive Chemistry Kaizen
              </h2>

              <p class="text-lg text-gray-700 mb-4">
                For over 400+ million learners in India & Global South
              </p>

              <p class="text-gray-700 leading-relaxed mb-6">
                A strategic collaboration between <strong>Think5Whys</strong> and 
                <strong>Dr. Gajanan Rashinkar</strong>, designed to create a world-class, 
                immersive, measurable, and personalized chemistry learning ecosystem.
              </p>
              <div class="space-y-12 mt-12">
                <div>
                  <h3 class="text-2xl font-semibold text-green-700 mb-2">
                    Periodic Table Champion
                  </h3>
                  <p class="text-sm text-gray-600 mb-4">
                    Class 6 to College | Entrance Exams
                  </p>

                  <p class="text-gray-700 leading-relaxed mb-4">
                    Periodic Table Champion is a unique initiative by Think5Whys & 
                    Dr. Gajanan Rashinkar to engage learners in immersive Periodic Table learning 
                    and certify them for deep knowledge mastery.
                  </p>

                  <p class="text-gray-700 leading-relaxed mb-4">
                    The Periodic Table is a fundamental tool in chemistry and science, offering 
                    a systematic organization of all known chemical elements based on their 
                    properties and atomic structure.
                  </p>

                  <p class="font-semibold mb-2">A thorough understanding is important for:</p>
                  <ul class="list-disc pl-6 text-gray-700 space-y-2">
                    <li>Fundamental Knowledge in Chemistry</li>
                    <li>Understanding Chemical Reactions</li>
                    <li>Basis for Advanced Study</li>
                    <li>Engineering and Industrial Applications</li>
                    <li>Environmental and Health Awareness</li>
                    <li>Innovation and Technology</li>
                    <li>Thorough Knowledge for Problem-Solving</li>
                  </ul>

                  <p class="text-gray-700 mt-4">
                    In summary, the periodic table is not just a reference chart but a gateway 
                    to understanding the material universe, fostering advancements in science, 
                    technology, and sustainability.
                  </p>

                  <p class="text-gray-700 mt-4">
                    Think5Whys Periodic Table Collection includes three immersive, highly 
                    personalized learning books designed to create visible and transparent 
                    learning qualifications beyond traditional learning processes.
                  </p>
                </div>
                <div>
                  <h3 class="text-2xl font-semibold text-blue-700 mb-2">
                    Chemistry MOBook
                  </h3>
                  <p class="text-sm text-gray-600 mb-4">
                    Class 6 to PhD | Competitive Exams
                  </p>

                  <p class="text-gray-700 leading-relaxed mb-4">
                    Chemistry MOBook is a unique immersive digital book framework supporting 
                    BYO (Build Your Own) / DIY (Do It Yourself) / EL (Experiential Learning).
                  </p>

                  <p class="text-gray-700 leading-relaxed mb-4">
                    It allows learners to create notes, question banks, vocabulary systems, 
                    dictionaries, abbreviations, glossaries, thesaurus, ontology, and 
                    structured topic networks in chemistry and related domains.
                  </p>

                  <p class="text-gray-700 leading-relaxed mb-4">
                    MOBook promotes a high level of personalization and measurable immersive learning.
                  </p>

                  <h4 class="font-semibold mt-6 mb-3">Example Use Case:</h4>
                  <p class="text-gray-700 mb-4">
                    Build your own digital book around a chemistry topic or technical word. 
                    This makes MOBook a high-utility educational product loved by students, 
                    professionals, and educators. It can be recommended by institutions, 
                    corporates, and government bodies.
                  </p>

                  <h4 class="font-semibold mt-6 mb-3">Advantages</h4>
                  <ul class="list-disc pl-6 text-gray-700 space-y-2">
                    <li>Offline digital notebook – Study Anywhere, Anytime</li>
                    <li>DIY structured learning tool for institutions</li>
                    <li>Homework / Assignment management tool</li>
                    <li>Experiential learning word-power builder</li>
                    <li>Quick ready-reckoner compared to dictionaries</li>
                    <li>Grow chemistry knowledge in your own words (guided by Dr. Rashinkar)</li>
                    <li>Daily / weekly tasks via Think5Whys SmartChem channels</li>
                    <li>Store translations in your own language</li>
                    <li>Mention source references</li>
                    <li>Revisit and revise anytime</li>
                    <li>Request quizzes via Chemistry Tonic</li>
                    <li>Share knowledge with mentors, parents, or peers</li>
                    <li>Jump to useful external references instantly</li>
                    <li>Quantify knowledge growth over time</li>
                    <li>No copyright issue on your own accumulated content</li>
                    <li>Build controlled word power</li>
                    <li>Regular app feature updates</li>
                    <li>Prevents exposure to unwanted ads</li>
                    <li>Record audio notes*</li>
                    <li>Attach images & maintain image gallery*</li>
                  </ul>

                  <p class="text-xs text-gray-500 mt-4">
                    *Upcoming features
                  </p>
                </div>
                <div>
                  <h3 class="text-2xl font-semibold text-purple-700 mb-2">
                    Chemistry Tonic
                  </h3>
                  <p class="text-sm text-gray-600 mb-4">
                    Class 6 onwards
                  </p>

                  <p class="text-gray-700 leading-relaxed mb-4">
                    Think5Whys Chemistry Tonic energizes learning the atomic way. 
                    Just as atoms are the building blocks of matter, Chemistry Tonic 
                    breaks complex learning into small, manageable, impactful steps.
                  </p>

                  <p class="text-gray-700 leading-relaxed">
                    Through bite-sized quizzes and expert-guided content, it ensures 
                    consistent progress without overwhelming learners. It complements 
                    the Think5Whys ecosystem while supporting learning in a different, 
                    highly engaging format.
                  </p>
                </div>

              </div>
              <div class="mt-16">
                <h3 class="text-2xl font-semibold mb-6">
                  User Segments
                </h3>

                <ul class="grid md:grid-cols-2 gap-3 text-gray-700">
                  <li>Middle School – Class 6 to 8</li>
                  <li>High School – Class 9 & 10</li>
                  <li>HSC – Class 11 & 12</li>
                  <li>Graduation & Post Graduation</li>
                  <li>Competitive Exam Aspirants</li>
                  <li>Research / PhD Scholars</li>
                  <li>Professionals</li>
                  <li>Teachers</li>
                  <li>Hobbyists</li>
                </ul>
              </div>

              <div class="mt-12 text-center text-gray-700 max-w-3xl mx-auto">
                <p>
                  Think5Whys as a platform is evolving rapidly and is committed to becoming 
                  a world-class immersive chemistry learning platform in its category.
                </p>
              </div>

            </div>
          </section>
        )}             
        {activeTab === "newchemistry" && (
          <section className="space-y-8 text-white">
            <div className="text-center space-y-3">
              <h2 className="text-2xl lg:text-3xl font-bold text-yellow-200">
                🧪 NewChemistry@Think5Whys
              </h2>
              <p className="text-sm lg:text-base text-gray-300 max-w-4xl mx-auto">
                A Kaizen Learning initiative empowering learners to master the evolving
                frontiers of chemistry through continuous improvement, innovation, and collaboration.
              </p>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-sm lg:text-base">
              {[
                "🌱 Green Chemistry",
                "🧱 Material Science",
                "🧬 Synthetic Biology",
                "💻 Computational Chemistry",
                "⚛️ Quantum Chemistry",
                "♻️ Chemical Recycling",
                "🔋 Energy Chemistry",
                "💊 Medicinal Chemistry",
              ].map((item, i) => (
                <div key={i} className="bg-gray-900 p-4 rounded-xl text-center">
                  {item}
                </div>
              ))}
            </div>
            <div className="bg-gray-900 p-6 rounded-2xl space-y-4 text-sm lg:text-base leading-relaxed">
              <p>
                <strong>NewChemistry@Think5Whys</strong> is rooted in the philosophy of 
                <span className="text-yellow-200"> Kaizen Learning</span> — the principle of 
                continuous improvement through incremental growth, exploration, and application.
              </p>
              <p>
                It bridges fragmented learning across websites, videos, AI tools, messaging apps,
                and traditional classrooms into a cohesive, data-driven, and collaborative framework.
              </p>
              <p>
                Designed for learners of all levels — students, teachers, professionals,
                researchers, and curious minds — it transforms chemistry education into
                a structured journey of discovery and innovation.
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-black border border-blue-400 p-6 rounded-2xl space-y-3 text-sm lg:text-base">
                <h3 className="text-lg font-semibold text-yellow-200">📖 Program Philosophy</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li>Build strong foundational chemical knowledge.</li>
                  <li>Explore emerging domains shaping the future.</li>
                  <li>Encourage collaborative & community-driven learning.</li>
                  <li>Innovate with purpose to solve global challenges.</li>
                </ul>
                <p className="text-gray-400 pt-3">
                  Chemistry becomes an ongoing journey of growth, discovery, and societal contribution.
                </p>
              </div>
              <div className="bg-black border border-blue-400 p-6 rounded-2xl space-y-4 text-sm lg:text-base">
                <h3 className="text-lg font-semibold text-yellow-200">✍️ Forewords</h3>
                <div>
                  <p className="font-semibold">Dr. Gajanan Rashinkar</p>
                  <p className="text-gray-400 text-sm">
                    Assistant Professor, Shivaji University, Kolhapur
                  </p>
                </div>
                <div className="pt-2">
                  <p className="font-semibold">Sanjeev Kumar</p>
                  <p className="text-gray-400 text-sm">
                    Founder, Architect & Program Director — Think5Whys <br />
                    Think5Whys Global DeepTech Solutions, Mumbai, India
                  </p>
                </div>
              </div>
            </div>
          </section>
        )}
        {activeTab === "stakeholders" && (
          <section className="space-y-2 text-sm">
            {stakeholders.map((item, i) => (
              <div key={i} className="bg-gray-900 p-3 rounded-lg">
                {item}
              </div>
            ))}
          </section>
        )}
        {activeTab === "features" && (
          <section className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {features.map((f, i) => (
              <div key={i} className="bg-gray-900 p-5 rounded-xl text-center">
                <div className="text-2xl mb-2">{f.emoji}</div>
                <h4 className="font-semibold text-yellow-200">{f.title}</h4>
                <p className="text-sm mt-2">{f.desc}</p>
              </div>
            ))}
          </section>
        )}
        {activeTab === "audience" && (
          <section className="space-y-4 text-sm">
            <h3 className="text-lg font-semibold text-yellow-200">
              📊 Estimated Target Audience
            </h3>
            <p>
              🇮🇳 India: 20–30 million serious chemistry learners including
              school, competitive and undergraduate students.
            </p>
            <p>
              🌍 Global: 50–100 million chemistry-engaged learners across
              secondary, higher education & STEM ecosystems.
            </p>
          </section>
        )}
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4 px-4 text-xs lg:text-sm">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          <p>&copy; 2026 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex space-x-6 mt-3 lg:mt-0">
            <Link to="/privacy-policy" className="hover:text-blue-300">Privacy</Link>
            <Link to="/terms-of-use" className="hover:text-blue-300">Terms</Link>
            <Link to="/contact-us" className="hover:text-blue-300">Contact</Link>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default ThinkChemistryWhy;
